import React from 'react';
import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import { BBPRDescriptionIcon } from '../../../../icons/prompt/bbPrDescription';
import { createInsertAtCurrentPosition } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
export var createPrDescription = function createPrDescription(options) {
  return {
    key: CONFIG_ITEM_KEYS.CREATE_PULL_REQUEST_DESCRIPTION,
    title: aiConfigItemMessages.prDescriptionTitle,
    description: aiConfigItemMessages.prDescriptionDescription,
    icon: function icon() {
      return /*#__PURE__*/React.createElement(BBPRDescriptionIcon, null);
    },
    endpoint: options.generativeAIApiUrl,
    intentSchemaId: 'bitbucket_pr_description_intent_schema.json',
    actions: {
      empty: [createInsertAtCurrentPosition({
        appearance: 'primary'
      })],
      selection: [createInsertAtCurrentPosition({
        appearance: 'primary'
      })]
    }
  };
};
export var createPrDescriptionWithOptions = function createPrDescriptionWithOptions(options) {
  return {
    config: createPrDescription(options),
    triggers: {
      empty: {
        enabled: true,
        docMinSize: 0
      },
      selection: {
        enabled: false
      },
      canShow: function canShow() {
        return !!options.generativeAIApiUrl;
      }
    }
  };
};